export enum WorkflowReportIntervalTypes {
    DAILY = "DAILY",
    HOURLY = "HOURLY"
}